export default __webpack_public_path__ + "static/media/back.4678a7d3.svg";